import {InPageAlert} from '@snsw-gel/react';
import React from 'react';
import {PhoneElement} from '../../utils/elements';

/**
 * Alert box to give info that a personal account has a claim which is actively processing and would block unlinking. This would
 * not be seen for tr2.
 */
const ClaimBeingProcessedAlert: React.JSX.Element = (
    <InPageAlert
        variant='warning'
        title={'Claim being processed'}
        id='claimBeingProcessed'
    >
        <p>
            You are not able to make changes to linked Personal toll accounts at this time as a claim is already being processed. When your claim has been completed, return to this page to make updates.
        </p>
        <p>
            If you need assistance, call us on {PhoneElement}.
        </p>
    </InPageAlert>
);

export default ClaimBeingProcessedAlert;
